/* EYS cart drawer: purchase order field, add-on recommendations, open-state helpers */
(function () {
  'use strict';

  var PO_ATTR = 'Purchase Order Number';

  var money = function (cents) {
    if (window.EYS && typeof window.EYS.money === 'function') return window.EYS.money(cents);
    return '£' + ((cents || 0) / 100).toFixed(2);
  };
  var session = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* unavailable */ } }
  };
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var postJSON = function (url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  };
  var syncHidden = function (value) {
    document.querySelectorAll('[data-eys-checkout-form]').forEach(function (form) {
      var hidden = form.querySelector('input[data-eys-po-hidden]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'attributes[' + PO_ATTR + ']';
        hidden.setAttribute('data-eys-po-hidden', '');
        form.appendChild(hidden);
      }
      hidden.value = value;
    });
  };

  /* ---------- Purchase order number ---------- */
  class EysPoField extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-eys-po-toggle]');
      this.field = this.querySelector('[data-eys-po-field]');
      this.input = this.querySelector('[data-eys-po-input]');
      this.error = this.querySelector('[data-eys-po-error]');
      this.saved = this.querySelector('[data-eys-po-saved]');
      if (!this.toggle || !this.input) return;

      this.lastSaved = this.input.value.trim();
      /* Keep the switch on across drawer re-renders while the number hasn't been typed yet */
      if (!this.toggle.checked && session.get('eys_po_on') === '1') {
        this.toggle.checked = true;
        this.field.hidden = false;
      }
      syncHidden(this.toggle.checked ? this.input.value.trim() : '');

      this.toggle.addEventListener('change', () => {
        var on = this.toggle.checked;
        session.set('eys_po_on', on ? '1' : '0');
        this.field.hidden = !on;
        this.hideError();
        if (on) {
          this.input.focus();
          syncHidden(this.input.value.trim());
        } else {
          this.input.value = '';
          syncHidden('');
          this.save('');
        }
      });

      var timer;
      this.input.addEventListener('input', () => {
        this.hideError();
        syncHidden(this.input.value.trim());
        clearTimeout(timer);
        timer = setTimeout(() => this.save(this.input.value.trim()), 600);
      });
      this.input.addEventListener('change', () => { clearTimeout(timer); this.save(this.input.value.trim()); });
      this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.input.blur(); } });
    }

    save(value) {
      if (value === this.lastSaved) return;
      this.lastSaved = value;
      var attrs = {};
      attrs[PO_ATTR] = value;
      postJSON('/cart/update.js', { attributes: attrs })
        .then(() => {
          if (!value || !this.saved) return;
          this.saved.hidden = false;
          clearTimeout(this.savedTimer);
          this.savedTimer = setTimeout(() => { this.saved.hidden = true; }, 1800);
        })
        .catch(() => { this.lastSaved = null; });
    }

    needsNumber() {
      return this.toggle && this.toggle.checked && !this.input.value.trim();
    }

    showError() {
      if (this.error) this.error.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
    }

    hideError() {
      if (this.error) this.error.hidden = true;
      this.input.removeAttribute('aria-invalid');
    }
  }

  /* Block checkout until a PO number is entered when the switch is on */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-eys-checkout-form] [name="checkout"]');
    if (!btn) return;
    var field = document.querySelector('#cart-items eys-po-field');
    if (field && typeof field.needsNumber === 'function' && field.needsNumber()) {
      e.preventDefault();
      e.stopPropagation();
      field.showError();
    }
  }, true);

  /* ---------- Add-on recommendations ---------- */
  class EysCartRecs extends HTMLElement {
    connectedCallback() {
      var id = this.dataset.productId;
      if (!id) return;
      this.inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
      this.gap = parseInt(this.dataset.gap || '0', 10) || 0;
      this.fsOn = this.dataset.fsOn === 'true';
      var key = 'eys_recs_' + id;
      var cached = session.get(key);
      if (cached) {
        try {
          var parsed = JSON.parse(cached);
          if (Date.now() - parsed.t < 30 * 60 * 1000) { this.render(parsed.p); return; }
        } catch (e) { /* ignore */ }
      }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=8&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then((data) => {
          var products = (data.products || []).map(function (p) {
            var single = p.variants && p.variants.length === 1;
            var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
            return {
              id: String(p.id), title: p.title, url: p.url, price: p.price, available: p.available,
              image: p.featured_image || (p.images && p.images[0]) || '',
              variant: v.id, single: single, varies: p.price_varies
            };
          });
          session.set(key, JSON.stringify({ t: Date.now(), p: products }));
          this.render(products);
        })
        .catch(function () {});
    }

    render(products) {
      var list = (products || []).filter((p) => p.available && this.inCart.indexOf(p.id) === -1).slice(0, 3);
      if (!list.length) { this.innerHTML = ''; return; }
      var nudge = this.fsOn && this.gap > 0;
      var heading = nudge ? 'Top up to free delivery' : 'You might also like';
      var sub = nudge ? 'Add ' + money(this.gap) + ' more with one of these popular add-ons' : '';
      var sized = function (src) {
        if (!src) return '';
        var s = src.indexOf('//') === 0 ? 'https:' + src : src;
        return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      };
      this.innerHTML =
        '<div class="eys-recs__head"><p class="eys-recs__title">' + escapeHtml(heading) + '</p>' +
        (sub ? '<p class="eys-recs__sub">' + escapeHtml(sub) + '</p>' : '') + '</div>' +
        '<ul class="eys-recs__list" role="list">' +
        list.map(function (p) {
          var action = p.single
            ? '<button type="button" class="eys-rec__add" data-eys-rec-add="' + escapeHtml(p.variant) + '" aria-label="Add ' + escapeHtml(p.title) + ' to basket"><span>Add</span></button>'
            : '<a class="eys-rec__add eys-rec__add--choose" href="' + escapeHtml(p.url) + '" aria-label="Choose options for ' + escapeHtml(p.title) + '">Choose</a>';
          return '<li class="eys-rec">' +
            '<a class="eys-rec__media" href="' + escapeHtml(p.url) + '" tabindex="-1" aria-hidden="true">' +
            (p.image ? '<img src="' + escapeHtml(sized(p.image)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
            '<div class="eys-rec__info"><a class="eys-rec__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
            '<span class="eys-rec__price">' + (p.varies ? 'From ' : '') + escapeHtml(money(p.price)) + ' <small>ex VAT</small></span></div>' +
            action + '</li>';
        }).join('') + '</ul>';

      this.querySelectorAll('[data-eys-rec-add]').forEach((btn) => {
        btn.addEventListener('click', () => this.add(btn));
      });
    }

    add(btn) {
      if (btn.disabled) return;
      var label = btn.querySelector('span');
      btn.disabled = true;
      btn.classList.add('is-busy');
      if (label) label.textContent = 'Adding';
      postJSON('/cart/add.js', { items: [{ id: Number(btn.dataset.eysRecAdd), quantity: 1 }] })
        .then(function () {
          if (window.EYS && window.EYS.cart) return window.EYS.cart.refresh({ open: true });
          window.location.reload();
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          if (label) label.textContent = 'Add';
          var msg = (err && (err.description || err.message)) || 'Sorry, that could not be added.';
          btn.setAttribute('title', msg);
        });
    }
  }

  if (!customElements.get('eys-po-field')) customElements.define('eys-po-field', EysPoField);
  if (!customElements.get('eys-cart-recs')) customElements.define('eys-cart-recs', EysCartRecs);

  /* ---------- Quantity errors ----------
     The theme swallows /cart/change errors (e.g. asking for more than is in stock) and leaves the
     typed quantity on screen. Re-render the true basket and explain what happened on that line. */
  var showLineError = function (line, message) {
    var target = line ? document.querySelector('#cart-items [data-eys-line-' + line + '] [data-render-error]') : null;
    if (!target) target = document.querySelector('#cart-items [data-render-error]');
    if (!target) return;
    target.textContent = message;
    target.classList.remove('hidden');
  };
  var onLineError = function (line, message) {
    var done = function () { showLineError(line, message); };
    if (window.EYS && window.EYS.cart && typeof window.EYS.cart.refresh === 'function') {
      window.EYS.cart.refresh().then(done, done);
    } else {
      done();
    }
  };
  if (window.fetch && !window.__eysCartFetchPatched) {
    window.__eysCartFetchPatched = true;
    var baseFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = baseFetch.apply(this, arguments);
      if (/\/cart\/change(\.js)?(\?|$)/.test(url)) {
        var line = null;
        try {
          var body = init && typeof init.body === 'string' ? JSON.parse(init.body) : null;
          if (body && body.line) line = body.line;
        } catch (e) { /* not JSON */ }
        p.then(function (res) {
          return res.clone().json().then(function (data) {
            var msg = data && (data.errors || data.description || (!res.ok && data.message));
            if (!msg) return;
            if (typeof msg !== 'string' || /parameter|invalid|not found/i.test(msg)) msg = 'Sorry, we couldn’t update your basket. Please try again.';
            onLineError(line, msg);
          });
        }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- Keep focus on the control that was used ----------
     After every update the theme swaps #cart-items and moves focus to the drawer itself. */
  var lastControl = null;
  var trackControl = function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('#cart-items')) return;
    var li = t.closest('[class~="eys-cd__item"]');
    var lineAttr = li && Array.prototype.find.call(li.attributes, function (a) { return a.name.indexOf('data-eys-line-') === 0; });
    if (!lineAttr) { lastControl = null; return; }
    var kind = t.matches('button[name="plus"]') ? 'plus' : t.matches('button[name="minus"]') ? 'minus' : t.matches('[name="updates[]"]') ? 'input' : t.closest('line-item-remove') ? 'remove' : null;
    lastControl = kind ? { line: lineAttr.name, kind: kind } : null;
  };
  /* pointerdown as well as focusin: Safari doesn't focus buttons on click */
  document.addEventListener('focusin', trackControl);
  document.addEventListener('pointerdown', trackControl, true);
  var restoreFocus = function () {
    if (!lastControl) return;
    var item = document.querySelector('#cart-items [' + lastControl.line + ']');
    var el = null;
    if (item) {
      if (lastControl.kind === 'plus') el = item.querySelector('button[name="plus"]');
      else if (lastControl.kind === 'minus') el = item.querySelector('button[name="minus"]:not([disabled])') || item.querySelector('[name="updates[]"]');
      else if (lastControl.kind === 'input') el = item.querySelector('[name="updates[]"]');
      else el = item.querySelector('line-item-remove button');
    }
    if (!el) el = document.querySelector('#cart-items .eys-cd__title');
    if (el) {
      if (!el.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT)$/.test(el.tagName)) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }
  };

  /* Flag on <html> while the cart drawer is visible, so floating widgets can step aside */
  var watchDrawer = function () {
    var modal = document.querySelector('.modal-component--cart-drawer');
    if (!modal || modal.__eysWatched) return;
    modal.__eysWatched = true;
    var update = function () {
      var open = window.getComputedStyle(modal).display !== 'none';
      document.documentElement.classList.toggle('eys-cart-open', open);
    };
    new MutationObserver(update).observe(modal, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
    var host = modal.closest('modal-component');
    if (host) new MutationObserver(update).observe(host, { attributes: true });
    update();
    /* #cart-items is replaced wholesale after each change: put focus back once the theme has finished */
    var body = modal.querySelector('.modal-component_body');
    if (body) {
      new MutationObserver(function (records) {
        var swapped = records.some(function (r) {
          return Array.prototype.some.call(r.addedNodes, function (n) { return n.id === 'cart-items'; });
        });
        if (swapped && document.documentElement.classList.contains('eys-cart-open')) window.setTimeout(restoreFocus, 0);
      }).observe(body, { childList: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
